<template>
<div id="zmap" :class="{'vertical': direction}">
    <div class="top-bar flex-y-center select-none">
        <div class="flex-grow-0 top-logo" v-if="logo" :style="{'background-image': `url(${logo})`}"></div>
        <div class="flex-grow-1 top-title">{{title}}</div>
        <div class="flex-grow-0 top-date pr top-item" v-if="time">{{time}}</div>
        <div class="flex-grow-0 top-weather flex-y-center pr top-item" v-if="weather && weather.temp">
            <div class="weather-icon flex-grow-0" :style="{'background-image': `url(${isDay ? weather.dayIcon : weather.nightIcon}`}"></div>
            <div v-if="weather.weather" class="flex-grow-0" style="margin: 0 10px 0 3px;">{{ weather.weather }}</div>
            <div class="flex-grow-0">{{weather.temp}}°C</div>
            <div v-if="weather.wind" class="flex-grow-0" style="margin-left: 3px;">{{weather.wind}}</div>
        </div>
    </div>
    <div class="map-wrap pr">
        <el-amap ref="map" :center="center" :zoom="zoom" :resizeEnable="true" :events="events" :features="features" class="zt-amap select-none">
            <template v-if="!luxianOpen && !curLine && curType && amapMarkers[curType]">
                <el-amap-marker v-for="marker in amapMarkers[curType]" :position="marker.position" :events="marker.events" :content="marker.content" :zIndex="marker.zIndex" :offset="marker.offset" :vid="marker.index" :key="marker.index"></el-amap-marker>
            </template>
            <template v-else-if="curLine && amapLines[curLine] && amapLines[curLine].amapMarkers">
                <el-amap-marker v-for="marker in amapLines[curLine].amapMarkers" :position="marker.position" :events="marker.events" :content="marker.content" :zIndex="marker.zIndex" :offset="marker.offset" :vid="marker.index" :key="marker.index"></el-amap-marker>
                <el-amap-polyline v-if="curPolyline" :zIndex="curPolyline.zIndex" :path="curPolyline.path" :strokeColor="curPolyline.strokeColor" :strokeWeight="curPolyline.strokeWeight" :strokeStyle="curPolyline.strokeStyle" :lineJoin="curPolyline.lineJoin" :key="curPolyline.index" :isOutline="guidePolyline.isOutline" :outlineColor="guidePolyline.outlineColor" :borderWeight="guidePolyline.borderWeight"></el-amap-polyline>
            </template>
            <el-amap-polyline ref="guidePolylineRef" :zIndex="guidePolyline.zIndex" :path="guidePolyline.path" :strokeColor="guidePolyline.strokeColor" :strokeWeight="guidePolyline.strokeWeight" :strokeStyle="guidePolyline.strokeStyle" :lineJoin="guidePolyline.lineJoin" :key="guidePolyline.index" :isOutline="guidePolyline.isOutline" :outlineColor="guidePolyline.outlineColor" :borderWeight="guidePolyline.borderWeight" :showDir="guidePolyline.showDir"></el-amap-polyline>
            <el-amap-info-window ref="infoWindowRef" :position="infoWindow.position" :visible="infoWindow.visible" :offset="infoWindow.offset" :size="infoWindow.size" :closeWhenClickMap="infoWindow.closeWhenClickMap" :autoMove="infoWindow.autoMove">
                <div class="info-wrap pr select-none flex-col">
                    <div class="flex-row flex-grow-1">
                        <div class="info-cover-wrap flex-grow-0">
                            <div class="info-cover pr cursor-pointer" :style="{'background-image': `url(${ curMarkerData.coverImg&&curMarkerData.coverImg!=file_url?curMarkerData.coverImg:curMarkerData.mapIcon })`}">
                                <div v-if="curMarkerData.audioUrl && curMarkerData.audioUrl[curAudioType]" class="icon-audio pa" :class="{'playing': curPlayingMarker && curPlayingMarker._amap_id == curMarker._amap_id && 1 == playingStatus}" @click="ctrlAudio(false)"></div>
                            </div>
                        </div>
                        <div class="flex-grow-1">
                            <div class="info-name text-more">{{ curMarkerData.name }}</div>
                            <div v-if="localMarker && curMarkerData.position" class="info-distance flex-y-center">
                                <span class="icon-distance"></span>距离您<span class="txt-distance">{{ marker2LocalDis }}</span>
                            </div>
                            <div v-if="curMarkerData.address" class="info-address flex-y-center text-more">
                                <span class="icon-address"></span>{{ curMarkerData.address }}
                            </div>
                        </div>
                    </div>
                    <div class="info-btns flex-row flex-grow-0">
                        <div class="info-btn flex-grow-1 flex-y-center flex-x-center cursor-pointer" @click="seeDetail">
                            <div class="info-btn-icon icon-detail"></div>查看详情
                        </div>
                        <div class="info-btn flex-grow-1 flex-y-center flex-x-center info-btn-go cursor-pointer" @click="goHere">
                            <div class="info-btn-icon icon-go"></div>到这里去
                        </div>
                    </div>
                </div>
            </el-amap-info-window>
            <el-amap-marker ref="localMarker" v-if="localMarker" :position="localMarker.position" :events="localMarker.events" :content="localMarker.content" :zIndex="localMarker.zIndex" :offset="localMarker.offset" :visible="localMarker.visible" :draggable="localMarker.draggable">
                <div class="locate-wrap pa select-none">
                    <div class="icon-screen-local pa"></div>
                </div>
            </el-amap-marker>
            <el-amap-marker v-if="goMarker" :position="goMarker.position" :events="goMarker.events" :content="goMarker.content" :zIndex="goMarker.zIndex" :offset="goMarker.offset" :vid="goMarker.index"></el-amap-marker>
        </el-amap>
        <div class="compass-wrap pa flex-x-center flex-y-center">
            <div class="icon-compass pr"></div>
        </div>
        <div class="float-btns-wrap pa select-none">
            <div class="float-btn flex-col flex-x-center flex-y-center cursor-pointer" :class="{'active': gaikuangOpen}" @click="gaikuangSwitch">
                <div class="float-icon icon-gaikuang"></div>
                <div class="float-text">信息概况</div>
            </div>
            <div v-if="vr" class="float-btn flex-col flex-x-center flex-y-center cursor-pointer" :class="{'active': vrOpen}" @click="vrSwitch">
                <div class="float-icon icon-vr"></div>
                <div class="float-text">全景VR</div>
            </div>
            <div class="float-btn flex-col flex-x-center flex-y-center cursor-pointer" :class="{'active': luxianOpen}" @click="luxianSwitch">
                <div class="float-icon icon-luxian"></div>
                <div class="float-text">旅游路线</div>
            </div>
        </div>
        <div class="navbar-wrap flex-y-center pa select-none">
            <div class="search-wrap flex-grow-0 cursor-pointer" @click="listSwitch">
                <div class="icon-search" :class="{'active': listOpen == true}"></div>
                <div>搜索</div>
            </div>
            <div class="flex-grow-0 icon-left cursor-pointer nav-next" ></div>
            <swiper class="nav-swiper flex-grow-1" v-if="markerTypes" :options="swiperNavOption" ref="navSwiper">
                <swiper-slide v-for="(markertype, index) in markerTypes" :key="index">
                    <div class="nav-item btnIcon cursor-pointer flex-x-center flex-y-center" :class="{'show': navActiveIndex == index}" @click="navClick(markertype.type, index)">
                        <div>
                            <div class="nav-icon" :style="{'background-image': `url(${markertype.defaultIcon})`}"></div>
                            <div class="nav-text">{{ markertype.name }}</div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            <div class="flex-grow-0 icon-right cursor-pointer nav-prev" ></div>
        </div>
        <div class="local-tip pa flex-y-center select-none">
            <div class="icon-local"></div>
            <div>您当前所在位置</div>
            <div v-if="showGuidePolyline">到{{ curMarkerData.name }}</div>
            <div class="icon-close-min flex-grow-0 cursor-pointer min" v-if="showGuidePolyline" @click="hideGuidePolyline(curTypeHide)"></div>
        </div>
        <div class="qrcode-wrap pa select-none" v-if="qrcode_url" :style="{'background-image': `url(${qrcode_url})`}"></div>
        <transition name="notice-fade">
            <div class="notice-wrap pa flex-y-center select-none" v-if="notice">
                <div class="icon-notice flex-grow-0 cursor-pointer" @click="noticeOpen = true"></div>
                <transition name="notice-list-fade">
                    <div class="notice-list flex-grow-1" v-if="noticeOpen">
                        <div class="notice-item pr ">
                            <div class="notice-anim" :style="{'animation-duration': `${noticeDuration}s`}">{{ notice }}</div>
                        </div>
                    </div>
                </transition>
                <div class="icon-close-min flex-grow-0 cursor-pointer" v-if="noticeOpen" @click="noticeOpen = false"></div>
            </div>
        </transition>
        <transition name="wrap-fade">
            <div class="panel-wrap pa" v-if="listOpen">
                <div class="panel-title flex-y-center">
                    <div class="flex-grow-0 panel-t-l flex-y-center"></div>
                    <div class="flex-grow-1 panel-t-c">搜索</div>
                    <div class="flex-grow-0 panel-t-r flex-y-center cursor-pointer" @click="listOpen = !listOpen;">
                        <div class="flex-grow-1"></div>
                        <div class="flex-grow-0 icon-close"></div>
                    </div>
                </div>
                <div class="list-search flex-y-center pr">
                    <div class="input-wrap flex-y-center">
                        <div class="icon-input-search flex-grow-0"></div>
                        <input v-model.trim="searchText" class="input-search flex-grow-1" type="text" placeholder="请输入地点" />
                    </div>
                </div>
                <div class="list-swiper-wrap pr select-none">
                    <swiper class="list-swiper" v-if="markers" :options="swiperWrapOption">
                        <swiper-slide>
                            <template v-for="(marker, index) in markers">
                                <!-- 是否选中 -->
                                <div class="flex-y-center list-item cursor-pointer"
                                v-if="(!searchText && marker.type == curType) || (searchText && marker.name.indexOf(searchText) != -1)" @click="listItemClick(marker.id)">
                                <!-- 当前存在audioUrl，和在播放的是当前点，或者不存在 -->
                                    <div class="flex-grow-0 list-icon" :style="{'background-image': `url(${markerTypes[navActiveIndex].activeIcon})`}"></div>
                                    <div class="flex-grow-1 list-text text-more">{{ marker.name }}</div>
                                </div>
                            </template>
                        </swiper-slide>
                        <!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->
                    </swiper>
                </div>
            </div>
        </transition>
        <transition name="wrap-fade-2top">
            <div class="panel-wrap select-none pa float-title p-center" v-if="markerDetailOpen">
                <div class="panel-title flex-y-center">
                    <div class="flex-grow-0 panel-t-l flex-y-center"></div>
                    <div class="flex-grow-1 panel-t-c"></div>
                    <div class="flex-grow-0 panel-t-r flex-y-center cursor-pointer" @click="markerDetailOpen = !markerDetailOpen">
                        <div class="flex-grow-1"></div>
                        <div class="flex-grow-0 icon-close"></div>
                    </div>
                </div>
                <div class="panel-swiper">
                    <swiper class="wrap-swiper" :options="swiperWrapOption">
                        <swiper-slide>
                            <div class="panel-cover-wrap" :style="{'background-image': `url(${markerDetail.coverImg})`}">
                                
                            </div>
                            <div class="panel-content gaikuang-content">
                                <div class="content-title flex-row">
                                    <div>{{curMarkerData.name}}</div>
                                </div>
                                <div v-if="marker2LocalDis" class="info-distance flex-y-center">
                                    <span class="icon-distance"></span>距离您<span class="txt-distance">{{ marker2LocalDis }}</span>
                                    <div class="flex-grow-1"></div>
                                    <div class="info-btns">
                                        <div class="info-btn flex-y-center info-btn-go cursor-pointer" @click="goHere">
                                            <div class="info-btn-icon icon-go"></div>去这里
                                        </div>
                                    </div>
                                </div>
                                <div v-if="curMarkerData.address" class="info-address flex-y-center">
                                    <span class="icon-address"></span><span class="txt-address">{{ curMarkerData.address }}</span>
                                </div>
                                <div style="height: 20px;"></div>
                                <template v-if="curMarkerData.audioUrl && curMarkerData.audioUrl[curAudioType]">
                                    <div class="panel-c-title">
                                        <div class="panel-c-t pr">语音讲解</div>
                                    </div>
                                    <div class="audio-ctrl-wrap flex-y-center">
                                        <div class="audio-cover pr flex-grow-0 pr cursor-pointer" :class="{'playing': curPlayingMarker && curPlayingMarker._amap_id == curMarker._amap_id && 1 == playingStatus}" @click="ctrlAudio(false)">
                                            <div class="icon-audio pa"></div>
                                        </div>
                                        <div class="flex-grow-0 audio-time l">{{curPlayingMarker && curPlayingMarker._amap_id == curMarker._amap_id ? currentTimeStr : '00:00'}}</div>
                                        <el-slider class="flex-grow-1" v-model="curPerAudio" :show-tooltip="false" @change="audioChage"></el-slider>
                                        <div class="flex-grow-0 audio-time r">{{curPlayingMarker && curPlayingMarker._amap_id == curMarker._amap_id ? durationTimeStr : '00:00'}}</div>
                                    </div>
                                    <div style="height: 30px;"></div>
                                </template>
                                <template v-if="markerDetail && markerDetail.content">
                                    <div class="panel-c-title">
                                        <div class="panel-c-t pr">基本信息</div>
                                    </div>
                                    <div class="ueditor-html" v-html="markerDetail.content"></div>
                                </template>
                                <!-- <div class="panel-c-title">
                                    <div class="panel-c-t pr">周边更多</div>
                                </div>
                                <swiper class="more-markers" :options="swiperSlideOption">
                                    <swiper-slide class="cursor-pointer" @click="moreMarkerClick">
                                        <div class="more-marker-cover"></div>
                                        <div class="more-marker-name text-more">竹苑永歌</div>
                                        <div class="more-marker-dis">距您<span>1.5km</span></div>
                                    </swiper-slide>
                                </swiper> -->
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
        </transition>
        <transition name="wrap-fade">
            <div class="panel-wrap select-none pa float-title" v-if="gaikuangOpen">
                <div class="panel-title flex-y-center">
                    <div class="flex-grow-0 panel-t-l flex-y-center"></div>
                    <div class="flex-grow-1 panel-t-c"></div>
                    <div class="flex-grow-0 panel-t-r flex-y-center cursor-pointer" @click="gaikuangOpen = !gaikuangOpen">
                        <div class="flex-grow-1"></div>
                        <div class="flex-grow-0 icon-close"></div>
                    </div>
                </div>
                <div class="panel-swiper">
                    <swiper class="wrap-swiper" :options="swiperWrapOption">
                        <swiper-slide>
                            <div class="panel-cover-wrap">
                                <swiper v-if="coverPics && coverPics[0]" :options="swiperAutoplayOption">
                                    <swiper-slide v-for="cover,index in coverPics" :key="index" :style="{'background-image': `url(${ cover })`}"></swiper-slide>
                                </swiper>
                            </div>
                            <div class="panel-content gaikuang-content">
                                <div class="content-title flex-row">
                                    <div>{{title}}</div>
                                </div>
                                <!-- <div v-if="dis" class="info-distance flex-y-center">
                                    <span class="icon-distance"></span>距离您<span class="txt-distance">{{ dis }}</span>
                                </div> -->
                                <div v-if="address" class="info-address flex-y-center">
                                    <span class="icon-address"></span><span class="txt-address">{{ address }}</span>
                                </div>
                                <div style="height: 20px;"></div>
                                <!-- <div class="panel-c-title">
                                    <div class="panel-c-t pr">语音讲解</div>
                                </div> -->
                                <template v-if="content">
                                    <div class="panel-c-title">
                                        <div class="panel-c-t pr">基本信息</div>
                                    </div>
                                    <div v-html="content" style="margin-bottom: 15px;"></div>
                                </template>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
        </transition>
        <transition name="wrap-fade">
            <div class="panel-wrap select-none pa float-title" v-if="vrOpen">
                <!-- <div class="panel-title flex-y-center">
                    <div class="flex-grow-0 panel-t-l flex-y-center cursor-pointer" @click="vrOpen = !vrOpen">
                        <div class="icon-return "></div>
                        <div>返回</div>
                    </div>
                    <div class="flex-grow-1 panel-t-c"></div>
                    <div class="flex-grow-0 panel-t-r flex-y-center">
                        <div class="flex-grow-1"></div>
                        <div class="flex-grow-0 icon-close"></div>
                    </div>
                </div> -->
                <div class="panel-swiper">
                    <iframe :src="vr" frameborder="no"></iframe>
                </div>
            </div>
        </transition>
        <transition name="wrap-fade">
            <div class="panel-wrap select-none pa" v-if="luxianOpen">
                <div class="panel-title flex-y-center">
                    <div class="flex-grow-0 panel-t-l"></div>
                    <div class="flex-grow-1 panel-t-c">旅游路线</div>
                    <div class="flex-grow-0 panel-t-r flex-y-center" @click="luxianSwitch">
                        <div class="flex-grow-1"></div>
                        <div class="flex-grow-0 icon-close cursor-pointer"></div>
                    </div>
                </div>
                <div class="panel-count">共{{lines.length}}条线路</div>
                <swiper class="panel-list" :options="swiperSlideOption">
                    <swiper-slide v-for="(line, index) in lines" class="flex-y-center cursor-pointer" :class="{'active': lineActiveIndex == index}" :key="index">
                        <div @click="switchLine(line.type)">{{ line.name }}</div>
                    </swiper-slide>
                </swiper>
                <swiper class="panel-swiper2" :options="swiperWrapOption">
                    <swiper-slide>
                        <div class="line-info" v-if="lines && lines[lineActiveIndex]">
                            <div class="line-descs flex-row">
                                <div class="line-desc" v-if="lines[lineActiveIndex].desc">{{ lines[lineActiveIndex].desc }}</div>
                                <div class="line-desc" v-if="lines[lineActiveIndex].date">{{ lines[lineActiveIndex].date }}</div>
                                <div class="line-desc" v-if="lines[lineActiveIndex].distance">{{ lines[lineActiveIndex].distance }}</div>
                            </div>
                            <swiper class="line-markers" :options="swiperSlideOption">
                                <swiper-slide class="line-marker pr" v-for="(marker, markerindex) in lines[lineActiveIndex].markers" :key="markerindex">
                                    <div class="line-marker-line"></div>
                                    <div class="line-marker-index flex-y-center flex-x-center pr cursor-pointer " :class="{'selected': luxianOpen && curMarkerData && curMarkerData.id == marker.marker_id}" @click="slideLineMarkerClick(marker.marker_id)">{{markerindex+1}}</div>
                                </swiper-slide>
                            </swiper>
                        </div>
                        <div class="line-marker-info" v-if="luxianOpen && curMarkerData">
                            <div class="info-name text-more">{{ curMarkerData.name }}</div>
                            <div v-if="localMarker && curMarkerData.position" class="info-distance flex-y-center">
                                <span class="icon-distance"></span>距离您<span class="txt-distance">{{ marker2LocalDis }}</span>
                            </div>
                            <template v-if="curMarkerData.content">
                                <div class="panel-c-title">
                                    <div class="panel-c-t pr">基本信息</div>
                                </div>
                                <div class="ueditor-html" v-html="curMarkerData.content"></div>
                            </template>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </transition>
        <div class="loading pa select-none" v-if="loadingShow">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <span class="weui-primary-loading weui-icon_toast">
                    <span class="weui-primary-loading__dot"></span>
                </span>
                <p class="weui-toast__content">加载中</p>
            </div>
        </div>
        <div class="pa select-none" v-if="!bound" style="z-index: 99999999999;">
            <div class="weui-mask weui-animate-fade-in">
                <div class="weui-half-screen-dialog weui-picker weui-animate-slide-up">
                    <div class="weui-half-screen-dialog__hd">
                        <div class="weui-half-screen-dialog__hd__main">
                            <strong class="weui-half-screen-dialog__title">设备绑定</strong>
                        </div>
                    </div>
                    <div class="weui-half-screen-dialog__bd">
                        <div class="weui-picker__bd" style="height: 260px;">
                            <div class="weui-picker__group">
                                <div class="weui-picker__mask" style="pointer-events: none;"></div>
                                <div class="weui-picker__indicator" style="pointer-events: none;"></div>
                                <swiper class="dev-swiper flex-grow-1" :options="swiperDevOption" ref="devSwiper">
                                    <swiper-slide v-for="(item, index) in devicesList" :key="index">
                                        <div role="option" class="weui-picker__item" aria-hidden="true">{{item.name}}</div>
                                    </swiper-slide>
                                </swiper>
                            </div>
                        </div>
                    </div>
                    <div class="weui-half-screen-dialog__ft">
                        <div class="weui-hidden_abs"></div><div class="weui-btn weui-btn_primary weui-picker__btn cursor-pointer" @click="bindDevice">绑定</div>
                    </div>
                </div>
            </div>
        </div>
        <transition name="msg-fade">
            <div class="tip-msg pa select-none" v-if="msgShow && msg" style="z-index: 99999999999;">
                <div class="tip-content" v-html="msg"></div>
            </div>
        </transition>
        <div class="loading pa select-none" v-if="pageLoadingShow" style="z-index: 999999999999;">
            <div class="weui-mask_transparent" style="background-color: #fff;"></div>
            <div class="weui-toast">
                <span class="weui-primary-loading weui-icon_toast">
                    <span class="weui-primary-loading__dot"></span>
                </span>
                <p class="weui-toast__content">初始化</p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
// const JSON5 = require('json5');
import { formatSecond2Minute, wgs84togcj02, getDistance, formatDistance, formatDistance2, getAngle } from '@/utils/utils';
import md5 from 'js-md5'
export default {
    name: 'index',
    components: { swiper, swiperSlide },
    data () {
        let self = this;
        let date = new Date();
        return {
            file_url: '',
            bound: false,
            pageLoadingShow: true,
            pk: this.$route.params.pk,
            did: this.$route.params.did,
            
            goMarker: null,
            direction: 0, // 大屏方向 默认0-横屏，1-竖屏
            timeId: null,
            time: null,
            loadingShow: false,
            logo: '',
            qrcode_url: '',
            msg: '',
            msgShow: false,
            msgTime: null,
            title: '',
            
            address: null,
            init: false,
            zoom: 15,
            center: [112.938882, 28.228337],
            curLocal: null,
            coverPics: null,
            features: [],
            content: null,
            events: {
                init: (o) => {
                    // o.setFeatures(['']);
                    // // 地图显示内容 bg(背景),road(道路),building(建筑物),point(标注)
                    // // o.setFeatures(['road', 'bg'])
                    if (self.pk) {
                        self.getMapInitInfo()
                        self.getMarkers()
                        self.getWeather()
                        self.initAudioEvent()
                    }
                },
                click: (o) => {
                    self.clearPanel();
                    let center = self.$refs.map.$$getInstance().getCenter();
                    console.log('center = ', center.lng+','+center.lat);
                    console.log('click = ', o.lnglat.lng+','+o.lnglat.lat);
                }
            },
            swiperDevOption: {
                slidesPerView: 5,
                direction: 'vertical',
                centeredSlides: true,
                mousewheelControl: true,
            },
            swiperNavOption: {
                slidesPerView: 'auto',
                navigation: {
                    nextEl: '.nav-next',
                    prevEl: '.nav-prev',
                },
            },
            swiperSlideOption: {
                slidesPerView: 'auto',
                freeMode: true,
                mousewheelControl: true,
            },
            swiperWrapOption: {
                slidesPerView: 'auto',
                direction: 'vertical',
                freeMode: true,
                roundLengths : true, //防止文字模糊
                mousewheelControl: true,
            },
            swiperAutoplayOption: {
                autoplay: {
                    delay: 5000,
                }
            },
            swiperAutoHeightOption: {
                autoHeight: true
            },
            
            curTypeHide: '', // 当前选中的兴趣点类型，隐藏记录
            curType: '', // 当前选中的兴趣点类型
            curAudioType: '', // 当前选中的音频类型
            markerTypes: [], // 兴趣点类型
            markers: [], // 兴趣点
            lines: [], // 推荐线路
            curLine: '', // 当前选中路线
            amapMarkers: {}, // 存放el-amap-marker配置值，{'type_1': [marker1, marker2], 'type_2': [marker3]}
            amapMarkersRefs: {}, // 存放生成之后的marker点位，高德地图Marker对象，{'type_1': [Marker1, Marker2], 'type_2': [Marker3]}，setContent是Marker对象的方法

            markerDetailOpen: false,

            vr: '',
            vrOpen: false,
            gaikuangOpen: false,
            
            luxianOpen: false,
            listOpen: false,
            curMarker: null, // 当前选中点
            curPlayingMarker: null, // 当前播放中的点
            searchText: null, // 搜索框
            markerOpen: false,
            markerAudio: new Audio(),
            seasonAudio: new Audio(),
            audioInit: false,
            playingStatus: 2, // -1-播放失败 0-加载中 1-播放中 2-暂停 
            isCtrlSeek: false, // 是否控制进度条
            currentTime: 0,
            durationTime: 0,
            infoWindow: {
                position: [112.938882, 28.228337],
                isCustom: true,
                size: [532, 246],
                offset: [0, -50],
                visible: false,
                closeWhenClickMap: true,
                autoMove: false,
                content: ''
            },
            notice: null,
            noticeDuration: 20,
            noticeOpen: true,
            setsWrapOpen: false,
            voiceWrapOpen: false,
            lineWrapOpen: false,
            audioTypes: [],
            isAuto: false,
            sosTel: '',
            serverTel: '',
            
            weather: null,
            isDay: date.getHours() >= 6 && date.getHours() <= 18,
            
            lineOpen: false,
            amapLines: {}, // {'line_1': {'amapMarkers': [], 'amapPolyline': null}, 'line_2': {'amapMarkers': [], 'amapPolyline': null}}
            amapLinesRefs: {}, // {'line_1': {'amapMarkersRefs': [], 'amapPolylineRefs': null}, 'line_2': {'amapMarkersRefs': [], 'amapPolylineRefs': null}}
            localMarker: null, // 当前点位配置
            localMarkerRef: null, // 当前点位amap，Marker对象
            localDemoEnable: false,
            orientationEnable: false,
            orientation: 0,
            boundPolygon: null, // 当前范围
            boundPolygonRef: null, // 当前范围amap，Polygon对象
            boundPolygonMsg: null, // 提示

            curPerAudio: 0,
            curPerAudioHide: 0,

            markerDetail: null,
            guidePolyline: {
                index: `hoo_guide_line_1`,
                zIndex: 122,
                path: [],
                strokeColor: '#4884fc',
                strokeStyle: 'solid',
                lineJoin: 'round',
                strokeWeight: 6,
                showDir: true,
                isOutline: true,
                outlineColor: '#3259ad',
                borderWeight: 2,
            },
            showGuidePolyline: false,
            
            devicesList: [],
        
        }
    },
    computed: {
        navActiveIndex() {
            let index = -1;
            if (this.curType && this.markerTypes && this.markerTypes[0]) {
                for (var i = 0, len = this.markerTypes.length; i < len; i++) {
                    if (this.curType == this.markerTypes[i].type) {
                        index = i;
                        break;
                    }
                }
            }
            return index;
        },
        curMarkerData() {
            let markerData = '';
            if (this.curMarker) markerData = this.curMarker.getExtData();
            return markerData;
        },
        curPolyline() {
            let polyline = null;
            if (this.curLine && this.amapLines[this.curLine].amapPolyline) polyline = this.amapLines[this.curLine].amapPolyline;
            return polyline;
        },
        marker2LocalDis() {
            if (this.curMarkerData && this.localMarker)
            return formatDistance2(getDistance(this.curMarkerData.position[0], this.curMarkerData.position[1], this.localMarker.position[0], this.localMarker.position[1]));
            else return '';
        },
        lineActiveIndex() {
            let index = -1;
            if (this.curLine && this.lines && this.lines[0]) {
                for (var i = 0, len = this.lines.length; i < len; i++) {
                    if (this.curLine == this.lines[i].type) {
                        index = i;
                        break;
                    }
                }
            }
            return index;
        },
        currentTimeStr() {
            return formatSecond2Minute(this.currentTime);
        },
        durationTimeStr() {
            return formatSecond2Minute(this.durationTime);
        }
    },
    methods: {
        showMsg(msg, duration) {
            if (!msg) return;
            let _duration = +duration || 2000;
            this.msgShow = true;
            this.msg = msg;
            clearTimeout(this.msgTime);
            this.msgTime = null;
            this.msgTime = setTimeout(() => {
                this.msgShow = false;
                this.msg = null;
                clearTimeout(this.msgTime);
                this.msgTime = null;
            }, _duration)
        },
        getZero(num) {
            // 单数前面加0
            if (parseInt(num) < 10) num = '0' + num;
            return num;
        },
        getMapInitInfo() {
            this.loadingShow = true;
            this.$http.get(`https://www.h5map.com/dev_api/get_device_map?pk=${this.pk}&did=${this.did}`).then(res => {
                if (res && res.data && res.data.data) {
                    this.pageLoadingShow = false;
                    this.loadingShow = false;
                    let data = res.data.data;
                    this.file_url = data.file_url;
                    this.bound = data.bound
            // this.$http.get('./static/mock/mapInitInfo.json5').then(res => {
            //     if (res && res.data) {
            //         var data = JSON5.parse(res.data);
            // console.log(data);
                    document.title = data.title;
                    
                    this.logo = data.logo;
                    this.qrcode_url = data.qrcode_url;
                    
                    this.vr = data.vr;
                    
                    this.title = data.title;

                    this.address = data.address;
                    this.coverPics = data.coverPics;
                    
                    this.content = data.content;
                    this.center = [+data.center[0], +data.center[1]];
                    this.curLocal = [+data.curLocal[0], +data.curLocal[1]];
                    this.initLocalMarker(data.curLocal[0], data.curLocal[1]);

                    this.zoom = data.initZoom;
                    this.devicesList = data.devices_list;

                    if (data.leftBottom[0] && data.leftBottom[1] && data.rightTop[0] && data.rightTop[1]) {
                        let path = [[data.rightTop[0], data.rightTop[1]], [data.rightTop[0], data.leftBottom[1]], [data.leftBottom[0], data.leftBottom[1]], [data.leftBottom[0], data.rightTop[1]]];
                        this.boundPolygon = {
                            path: path,
                            visible: true,
                            events: {
                                init: (o) => {
                                    this.boundPolygonRef = o;
                                    this.boundPolygon.visible = false;
                                }
                            }
                        }
                    } 

                    if(data.markerTypes && data.markerTypes[0]) {
                        this.curType = data.markerTypes[0].type;
                        this.curTypeHide = data.markerTypes[0].type;
                    }

                    this.curAudioType = (data.audioTypes && data.audioTypes[0] && data.audioTypes[0].key);
                    this.markerTypes = data.markerTypes;
                    // this.markers = data.markers;
                    this.lines = data.lines;
                    this.notice = data.notice;
                    this.noticeDuration = data.noticeDuration;
                    this.audioTypes = data.audioTypes;
                    this.sosTel = data.sosTel;
                    this.serverTel = data.serverTel;

                    if (!this.tileLayer) {
                        let tilePrifix = data.tileUrlTemplate && data.tileUrlTemplate.split('{z}/{x}_{y}');
                        tilePrifix = tilePrifix[0];
                        this.tileLayer = new AMap.TileLayer.Flexible({
                            cacheSize: 30,
                            zIndex: 119,
                            createTile: function (x, y, z, success, fail) {
                                var img = document.createElement('img')
                                img.onload = function () {
                                    success(img)
                                }
                                img.onerror = function () {
                                    img.src = '/static/images/background.png'
                                    success(img)
                                }
                                img.src = `${tilePrifix}${z}/${x}_${y}.png`;
                            }
                        })
                        this.$refs.map.$$getInstance().add(this.tileLayer);
                    }

                    this.$nextTick(() => {
                        this.$refs.linesSwiper && this.$refs.linesSwiper.swiper && this.$refs.linesSwiper.swiper.slideTo(this.lineActiveIndex, 0);
                        this.init = true;
                    });
                }
            });
        },
        getWeather() {
            this.$http.get(`https://www.h5map.com/dev_api/weather?pk=${this.pk}`).then(res => {
                if (res && res.data && res.data.data) {
                    this.weather = res.data.data;
                }
            });
        },
        getMarkers() {
            this.$http.get(`https://www.h5map.com/dev_api/markers?pk=${this.pk}`).then(res => {
                if (res && res.data && res.data.data) {
                    this.markers = res.data.data;
                    this.initAmapMarker(res.data.data);
                }
            });
        },
        bindDevice() {
            let dev = this.devicesList[this.$refs.devSwiper.swiper.activeIndex];
            if (!dev) return;
            this.$http.post(`https://www.h5map.com/dev_api/bind_device`, {
                dk: dev.dk,
                did: this.did
            }).then(res => {
                res = res.data;
                this.bound = res.data.bound;
                this.showMsg(res.data.msg);
                if (res.data.bound) {
                    dev.lng && dev.lat && (this.center = [+dev.lng, +dev.lat]);
                    dev.dev_lng && dev.dev_lat && (this.curLocal = [+dev.dev_lng, +dev.dev_lat], this.localMarker.position = this.curLocal);
                    dev.logo && (this.logo = dev.logo);
                    dev.qrcode && (this.qrcode_url = dev.qrcode);
                    console.log(this.curLocal);
                }
            });
        },
        initAmapMarker(markers) {
            if (!markers) return;
            for (var i = 0, len = markers.length; i < len; i++) {
                ;(function (marker, self, i) {
                    if (!self.amapMarkers[marker.type]) self.amapMarkers[marker.type] = [];
                    let temp = {
                        index: `hoo_marker_${marker.id}`,
                        position: [marker.position[0], marker.position[1]],
                        offset: [-12, -12],
                        zIndex: 121+(len-i),
                        content: `<div class="pa marker-label"><div class="text-more">${marker.name}</div></div>
                        <div class="pa marker-icon"><div class="icon" style="background-image: url(${marker.mapIcon});"></div></div>`,
                        events: {
                            init(o) {
                                if (!self.amapMarkersRefs[marker.type]) self.amapMarkersRefs[marker.type] = [];
                                if (self.amapMarkersRefs[marker.type].length == self.amapMarkers[marker.type].length)
                                self.amapMarkersRefs[marker.type].length = 0;
                                o.setExtData({
                                    id: marker.id,
                                    type: marker.type,
                                    name: marker.name,
                                    position: marker.position,
                                    coverImg: marker.coverImg,
                                    mapIcon: marker.mapIcon,
                                    audioUrl: marker.audioUrl,
                                    content: marker.content,
                                    autoRadius: marker.autoRadius,
                                    isCollected: marker.isCollected,
                                    isClocked: marker.isClocked,
                                    address: marker.address,
                                });
                                self.amapMarkersRefs[marker.type].push(o);
                            },
                            click(e) {
                                self.markerClick(e.target);
                            }
                        }
                    };
                    self.amapMarkers[marker.type].push(temp);
                })(markers[i], this, i);
            }
        },
        initLocalMarker(lng, lat) {
            let self = this;
            if (!this.localMarker) this.localMarker = {
                position: [lng, lat],
                offset: [-12, -24],
                zIndex: 999,
                content: '',
                draggable: false,
                visible: true,
                events: {
                    init(o) {
                        self.localMarkerRef = o;
                    },
                }
            }
        },
        initAudioEvent() {
            this.markerAudio.addEventListener('waiting', () => {
                this.playingStatus = 0;
            });
            this.markerAudio.addEventListener('canplay', () => {
                this.playingStatus = 0;
            });
            this.markerAudio.addEventListener('error', () => {
                this.playingStatus = -1;
            });
            this.markerAudio.addEventListener('timeupdate', () => {
                this.playingStatus = 1;
                if (this.curPlayingMarker && this.curPlayingMarker._amap_id == this.curMarker._amap_id) {
                    if (!this.isCtrlSeek) {
                        this.currentTime = this.markerAudio.currentTime || 0;
                        this.durationTime = this.markerAudio.duration || 0;
                        this.curPerAudio = Math.round(this.markerAudio.currentTime / this.markerAudio.duration * 100);
                        this.curPerAudioHide = this.curPerAudio;
                    }
                } else {
                    this.currentTime = 0;
                    this.durationTime = 0;
                    this.curPerAudio = 0;
                }
            });
            this.markerAudio.addEventListener('pause', () => {
                this.playingStatus = 2;
            });
            this.markerAudio.addEventListener('ended', () => {
                this.curPlayingMarker = null;
                this.playingStatus = 2;
            });
        },
        ctrlAudio(isAuto) {
            if (!this.curMarker) return;
            if (!isAuto && this.isAuto) {
                // 自动模式下，手动点击
                this.isAuto = false;
                // this.showMsg('已切换到手动播放模式');
            }
            if (!this.audioInit) this.audioInit = true;
            if (this.curPlayingMarker && this.curPlayingMarker._amap_id != this.curMarker._amap_id) {
                // 上一个播放的点不是当前点击播放的点
                // let extData = this.curPlayingMarker.getExtData();
            }
            if (this.curPlayingMarker && this.curPlayingMarker._amap_id == this.curMarker._amap_id) {
                // 同一个点位
                if (!this.isAuto) {
                    // 手动模式下才频繁切换暂停播放
                    if (1 == this.playingStatus) {
                        this.markerAudio.pause();
                        // this.seasonAudio.pause();
                    }
                    else {
                        this.markerAudio.play();
                        // this.seasonAudio.play();
                    }
                }
            } else {
                // 不同点位
                let extData = this.curMarker.getExtData();
                this.curPlayingMarker = this.curMarker;
                this.markerAudio.src = extData.audioUrl[this.curAudioType];
                this.markerAudio.play();
            }
        },
        navClick(markerType, index) {
            if (this.curType && this.curType == markerType) return;
            if (this.goMarker) this.hideGuidePolyline(this.curTypeHide);
            this.$refs.navSwiper.swiper.slideTo(index);
            this.clearPanel();
            this.clearMarker();
            this.curType = markerType;
            this.curTypeHide = markerType;
            this.fitView();
        },
        clearPanel() {
            this.closeLuxian();
            this.vrOpen = false;
            this.gaikuangOpen = false;this.luxianOpen = false;
            this.listOpen = false;
            this.markerDetailOpen = false;
        },
        clearMarker() {
            this.markerClose();
            this.curMarker = null;
            this.curPlayingMarker = null;
            this.markerAudio.pause();
        },
        _renderCluserMarker(context) {
            let markers = context.markers;
            let cluserName = markers[0].getExtData().name;
            let cluserIcon = markers[0].getExtData().mapIcon;
            
            let cluserContent =  `<div class="pa marker-label"><div class="text-more">${cluserName.slice(0, 5)}...等</div></div>
                                <div class="pa marker-icon icon-cluser flex-x-center flex-y-center"
                                ><div class="icon" style="background-image: url(${cluserIcon});"></div></div>`;
            context.marker.setContent(cluserContent)
        },
        listItemClick(marker_id) {
            for (var i = 0, len = this.amapMarkersRefs[this.curType].length; i < len; i++) {
                var markerRefs = this.amapMarkersRefs[this.curType][i],
                    extData = markerRefs.getExtData();
                if (marker_id == extData.id) {
                    this.markerClick(markerRefs);
                    break;
                }
            }
        },
        markerClick(marker) {
            if (!marker) return;
            // this.listOpen = false;
            this.markerOpen = true;
            let markerData = marker.getExtData();
            // this.center = [markerData.position[0], markerData.position[1]];
            this.$nextTick(() => {
                this.$refs.infoWindowRef.$$getInstance().open(this.$refs.map.$$getInstance(), [markerData.position[0], markerData.position[1]]);
            });
            if (this.curMarker && this.curMarker._amap_id != marker._amap_id) {
                // 上一个点存在，且不是当前所点击点
            }
            if (this.curMarker && this.curMarker._amap_id == marker._amap_id) {
                // 同一点位
                return;
            }
            this.curMarker = marker;
        },
        lineMarkerClick(marker) {
            if (!marker) return;
            this.markerOpen = true;
            // this.lineOpen = false;
            this.curMarker = marker;
            let markerData = marker.getExtData();
            // this.center = [markerData.position[0], markerData.position[1]];
            // this.$nextTick(() => {
            //     this.$refs.infoWindowRef.$$getInstance().open(this.$refs.map.$$getInstance(), [markerData.position[0], markerData.position[1]]);
            // });
        },
        slideLineMarkerClick(marker_id) {
            for (var i = 0, len = this.amapLinesRefs[this.curLine].amapMarkersRefs.length; i < len; i++) {
                var markerRefs = this.amapLinesRefs[this.curLine].amapMarkersRefs[i],
                    extData = markerRefs.getExtData();
                if (marker_id == extData.id) {
                    this.lineMarkerClick(markerRefs);
                    break;
                }
            }
        },
        markerClose() {
            this.markerOpen = false;
            this.markerDetailOpen = false;
            this.$refs.infoWindowRef.$$getInstance().close();
        },
        listSwitch() {
            this.closeLuxian();
            if (this.goMarker) this.hideGuidePolyline(this.curTypeHide);
            if (this.listOpen) {
                this.listOpen = false;
            } else {
                this.clearPanel();
                this.listOpen = true;
            }
            this.fitView();
        },
        vrSwitch() {
            this.closeLuxian();
            if (this.vrOpen) {
                this.vrOpen = false;
            } else {
                this.clearPanel();
                this.vrOpen = true;
            }
            this.markerClose();
            this.fitView();
        },
        gaikuangSwitch() {
            this.closeLuxian();
            if (this.gaikuangOpen) {
                this.gaikuangOpen = false;
            } else {
                this.clearPanel();
                this.gaikuangOpen = true;
            }
            this.markerClose();
            this.fitView();
        },
        closeLuxian() {
            if (this.luxianOpen) {
                // 关闭旅游线路
                this.luxianOpen = false;
                this.curLine = '';
                this.curType = this.curTypeHide;
            }
        },
        luxianSwitch() {
            let doLuxian = () => {
                if (this.goMarker) this.hideGuidePolyline();
                if (this.luxianOpen) {
                    this.closeLuxian();
                } else {
                    // 显示旅游线路
                    this.curType = '';
                    this.clearPanel();
                    this.luxianOpen = true;
                    this.switchLine(this.lines[0].type);
                }
                this.fitView();
            }
            if (this.lines && this.lines[0]) {
                doLuxian();
            } else {
                if (!this.luxianOpen) {
                    this.loadingShow = true;
                    this.$http.get(`https://www.h5map.com/dev_api/lines?pk=${this.pk}`).then(res => {
                        this.loadingShow = false;
                        if (res && res.data && res.data.data && res.data.data[0]) {
                            let lines = res.data.data;
                            for (let i = 0, lenI = lines.length; i < lenI; i++) {
                                for (let j = 0, lenJ = lines[i].markers.length; j < lenJ; j++) {
                                    for (let k = 0, lenK = this.markers.length; k < lenK; k++) {
                                        if (lines[i].markers[j].marker_id == this.markers[k].id) {
                                            lines[i].markers[j].marker = this.markers[k];
                                            break;
                                        }
                                    }
                                }
                            }
                            this.lines = lines;
                            doLuxian();
                        } else this.showMsg('当前暂无旅游路线相关内容');
                    });
                } else doLuxian();
            }
        },
        switchLine(type) {
            this.curLine = type;
            this.clearMarker();
            if (!this.amapLines[this.curLine]) this.initAmapLine(this.lines[this.lineActiveIndex]);
            this.fitView();
        },
        fitView() {
            this.markerClose();
            // this.$nextTick(() => {
            //     this.$refs.map.$$getInstance().setFitView();
            // });
        },
        initAmapLine(line) {
            if (!line) return;
            if (line.markers && line.markers[0]) for (var j = 0, lenJ = line.markers.length; j < lenJ; j++) {
                ;(function (line, marker, self, j) {
                    if (!self.amapLines[line.type]) self.amapLines[line.type] = {'amapMarkers': [], 'amapPolyline': null};
                    let temp = {
                        index: `hoo_linemarker_${line.id}_${marker.id}`, // ！！这里的index一定不能重复
                        position: [marker.position[0], marker.position[1]],
                        offset: [-12, -12],
                        zIndex: 121+(lenJ-j),
                        content: `<div class="pa marker-label"><div class="text-more">${marker.name}</div></div>
                        <div class="pa marker-icon"><div class="icon" style="background-image: url(${marker.mapIcon});"></div></div>`,
                        events: {
                            init(o) {
                                // 这里初始线路时候触发了。其他线路中的marker未init，但是，上面marker切换类型的时候又会触发
                                // 第一次init不会触发，之后 curType slidechange 切换显示隐藏的时候 会触发
                                if (!self.amapLinesRefs[line.type]) self.amapLinesRefs[line.type] = {'amapMarkersRefs': [], 'amapPolylineRefs': null};
                                if (self.amapLinesRefs[line.type].amapMarkersRefs.length == self.amapLines[line.type].amapMarkers.length)
                                self.amapLinesRefs[line.type].amapMarkersRefs.length = 0;
                                o.setExtData({
                                    id: marker.id,
                                    type: marker.type,
                                    name: marker.name,
                                    position: marker.position,
                                    coverImg: marker.coverImg,
                                    mapIcon: marker.mapIcon,
                                    audioUrl: marker.audioUrl,
                                    content: marker.content,
                                    autoRadius: marker.autoRadius,
                                    isCollected: marker.isCollected,
                                    isClocked: marker.isClocked,
                                });
                                self.amapLinesRefs[line.type].amapMarkersRefs.push(o);
                            },
                            click(e) {
                                self.lineMarkerClick(e.target);
                            }
                        }
                    };
                    self.amapLines[line.type].amapMarkers.push(temp);
                })(line, line.markers[j].marker, this, j);
            }
            if (line.points && line.points[0]) {
                if (!this.amapLines[line.type]) this.amapLines[line.type] = {'amapMarkers': [], 'amapPolyline': null};
                var path = [];
                for (var i = 0, lenI = line.points.length; i < lenI; i++) {
                    // var point = line.points[i].split(',');
                    var point = line.points[i];
                    path.push([Number(point[0]), Number(point[1])]);
                }
                this.amapLines[line.type].amapPolyline = {
                    index: `hoo_line_${line.id}`,
                    zIndex: 122,
                    path: path,
                    strokeColor: '#319ef0',
                    strokeStyle: 'solid',
                    lineJoin: 'round',
                    strokeWeight: 8,
                    isOutline: true,
                    outlineColor: '#4b3525',
                    borderWeight: 2,
                };
            }
        },
        seeDetail() {
            if (!this.curMarkerData) return;
            let doSeeDetail = () => {
                this.clearPanel();
                this.markerDetailOpen = true;
                if (this.curPlayingMarker && this.curPlayingMarker._amap_id == this.curMarker._amap_id) {
                    this.curPerAudio = this.curPerAudioHide;
                } else {
                    this.curPerAudio = 0;
                }
            };
            if (this.markerDetail && this.markerDetail.id == this.curMarkerData.id) doSeeDetail();
            else {
                this.markerDetail = this.curMarkerData;
                doSeeDetail();
                // this.loadingShow = true;
                // this.$http.get(`https://www.h5map.com/dev_api/marker?id=${this.curMarkerData.id}`).then(res => {
                //     this.loadingShow = false;
                //     if (res && res.data && res.data.data) {
                //         this.markerDetail = res.data.data;
                //         doSeeDetail();
                //     } else this.showMsg('当前暂无详情相关内容');
                // });
            }
        },
        goHere() {
            if (!this.curMarkerData) return;
            let extData = this.$refs.guidePolylineRef.$$getInstance().getExtData();
            let self = this;
            if (this.curMarkerData.id != extData.__marker_id) {
                this.loadingShow = true;
                this.$http.get(`https://www.h5map.com/dev_api/walking?origin=${this.curLocal[0]},${this.curLocal[1]}&destination=${this.curMarkerData.position[0]},${this.curMarkerData.position[1]}`).then(res => {
                    this.loadingShow = false;
                    let data = res.data;
                    if (data.count > 0 && data.route && data.route.paths && data.route.paths[0] && data.route.paths[0].steps) {
                        this.curType = '';
                        this.goMarker = {
                            index: `zt_hoo_marker_${this.curMarkerData.id}`,
                            position: [this.curMarkerData.position[0], this.curMarkerData.position[1]],
                            offset: [-12, -12],
                            zIndex: 122,
                            content: `<div class="pa marker-label"><div class="text-more">${this.curMarkerData.name}</div></div>
                            <div class="pa marker-icon"><div class="icon" style="background-image: url(${this.curMarkerData.mapIcon});"></div></div>`,
                            events: {
                                init(o) {
                                    o.setExtData({
                                        id: this.curMarkerData.id,
                                        type: this.curMarkerData.type,
                                        name: this.curMarkerData.name,
                                        position: this.curMarkerData.position,
                                        coverImg: this.curMarkerData.coverImg,
                                        mapIcon: this.curMarkerData.mapIcon,
                                        audioUrl: this.curMarkerData.audioUrl,
                                        content: this.curMarkerData.content,
                                        autoRadius: this.curMarkerData.autoRadius,
                                        isCollected: this.curMarkerData.isCollected,
                                        isClocked: this.curMarkerData.isClocked,
                                        address: this.curMarkerData.address,
                                    });
                                },
                                click(e) {
                                    self.markerClick(e.target);
                                }
                            }
                        };
                        extData.__marker_id = this.curMarkerData.id;
                        this.$refs.guidePolylineRef.$$getInstance().setExtData(extData);

                        let origin = data.route.origin && data.route.origin.split(','),
                            destination = data.route.destination && data.route.destination.split(','),
                            pathData = data.route.paths[0],
                            steps = pathData.steps,
                            path = [];
                        for (var i = 0, lenI = steps.length; i < lenI; i++) {
                            var step = steps[i], polyline = step.polyline, polylineArr = polyline.split(';');
                            for (var j = 0, lenJ = polylineArr.length; j < lenJ; j++) {
                                var point = polylineArr[j],
                                    position = point.split(',');
                                // // 检测最后一个点位是否重复 去重
                                if ((path.length > 0 && path[path.length - 1].lng != position[1] && path[path.length - 1].lat != position[0]) || path.length == 0)
                                path.push([+position[0], +position[1]]);
                            }
                        }
                        // this.guidePolyline = ;
                        let options = this.$refs.guidePolylineRef.$$getInstance().getOptions();
                        ;
                        options.showDir = true;
                        options.borderWeight = 2;
                        options.path = path;
                        this.$refs.guidePolylineRef.$$getInstance().setOptions(options);
                        this.$refs.guidePolylineRef.$$getInstance().show();
                        this.showGuidePolyline = true;
                        this.fitView();
                    } else this.showMsg('当前暂无导航相关内容');
                });
            } else {
                this.$refs.guidePolylineRef.$$getInstance().show();
                this.showGuidePolyline = true;
                this.fitView();
            }
        },
        hideGuidePolyline(curType) {
            curType && (this.curType = curType);
            this.goMarker = null;
            this.$refs.guidePolylineRef.$$getInstance().hide();
            this.showGuidePolyline = false;
        },
        moreMarkerClick() {

        },
        audioChage() {
            if (1 == this.playingStatus) {
                // 播放中
                this.isCtrlSeek = true;
                this.markerAudio.currentTime = this.durationTime * this.curPerAudio / 100;
                this.isCtrlSeek = false;
            }
        },
    },
    mounted() {
        let updateArr = [];
        for (var i = 0; i < 24; i ++) {
            // j+3 每半小时自动刷新一次
            for (var j = 0; j < 6; j=j+3) {
                // updateArr.push((i<10?'0'+i:i)+':'+(j==0?'00':'30')+':00');
                updateArr.push((i<10?'0'+i:i)+':'+j+'0:00');
            }
        }
        document.body.clientHeight >= document.body.clientWidth ? this.direction = 1 : this.direction = 0;
        window.onresize = () => {
            document.body.clientHeight >= document.body.clientWidth ? this.direction = 1 : this.direction = 0;
        }
        clearInterval(this.timeId);
        this.timeId = setInterval(() => {
            let date = new Date();
            let month= date.getMonth() + 1;
            let day = date.getDate();
            let hour = this.getZero(date.getHours());
            let min = this.getZero(date.getMinutes());
            let sec = this.getZero(date.getSeconds());
            let d = date.getDay();
            let weekday = ["星期日","星期一","星期二","星期三","星期四","星期五","星期六"];
            this.time = `${this.getZero(month)}月${this.getZero(day)}日 ${weekday[d]} ${hour}:${min}:${sec}`;
            if (updateArr.indexOf(hour + ":" + min + ":" + sec) > 0) {
                console.log(hour + ":" + min + ":" + sec);
                if (typeof window.web_bridge !== 'undefined') window.web_bridge.reload();
                else location.reload();
            }
        }, 1000);
    },
    beforeDestroy() {
        this.markerAudio.pause();
        clearInterval(this.timeId);
    },
    // activated() {
    // },
    // deactivated() {
    // }
}
</script>
<style lang='stylus'>
#zmap {
    width: 100%;
    height: 100%;
.top-bar {
    padding: 0 78px;
    width: 100%;
    height: 88px;
    background-color: #fff;
    z-index: 999999;
}
.top-title {
    font-size: 26px;
}
.top-logo {
    margin-right: 10px;
    width: 70px;
    height: 70px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}
.top-date {
    font-size: 20px;
}
.top-weather {
    height: 40px;
    font-size: 20px;
    .weather-icon {
        width: 40px;
        height: 40px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }
}
.top-item {
    line-height: 1;
    & +.top-item {
        padding-left: 40px;
        &::before {
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            left: 20px;
            width: 1px;
            height: 39px;
            background: #ededed;
            transform: translateY(-50%);
        }
    }
}
.map-wrap {
    width: 100%;
    height: calc(100% - 88px);
}
.compass-wrap {
    top: 29px;
    right: 11px;
    width: 100px;
    height: 100px;
    background: #FFFFFF;
    box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.2);
    border-radius: 50px;
    z-index: 999999;
    &::before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 43px;
        height: 43px;
        border: 2px solid #E0E3F9;
        border-radius: 22px;
        transform: translate(-50%, -50%);
    }
    .icon-compass {
        width: 13px;
        height: 52px;
        background: url(../assets/images/icon-compass.png) no-repeat center;
        background-size: 100%;
        &::before,
        &::after {
            content: '北';
            display: block;
            position: absolute;
            top: -18px;
            left: 50%;
            transform: translateX(-50%);
            font-size: 14px;
        }
        &::after {
            content: '南';
            top: unset;
            bottom: -18px;
        }
    }
}
.float-btns-wrap {
    top: 180px;
    right: 20px;
    z-index: 999999;
    .float-btn {
        width: 80px;
        height: 80px;
        line-height: 1;
        box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.2);
        background: #fff;
        border-radius: 20px;
        &+.float-btn {
            margin-top: 10px;
        }
        .float-icon {
            margin-bottom: 8px;
            width: 46px;
            height: 36px;
            background: url(../assets/images/icon-gaikuang.png) no-repeat center;
            background-size: contain;
            &.icon-vr {
                background-image: url(../assets/images/icon-vr.png);
            }
            &.icon-luxian {
                background-image: url(../assets/images/icon-luxian.png);
            }
        }
        &.active {
            color: #fff;
            background: #319ef0;
            .icon-gaikuang {
                background-image: url(../assets/images/icon-gaikuang-active.png);
            }
            .icon-vr {
                background-image: url(../assets/images/icon-vr-active.png);
            }
            .icon-luxian {
                background-image: url(../assets/images/icon-luxian-active.png);
            }
        }
    }
}
.marker-icon {
    top: 50%;
    left: 50%;
    margin-top: -40px;
    width: 52px;
    height: 52px;
    transform: translate(-50%);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url(../assets/images/icon-marker-bg.png);
    .icon {
        position: absolute;
        top: 4px;
        left: 50%;
        width: 38px;
        height: 38px;
        transform: translateX(-50%);
        border-radius: 50%;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
}
.marker-icon.icon-cluser {
    font-size: 14px;
}
.marker-label {
    top: 100%;
    left: 50%;
    margin-top: 4px;
    padding: 6px 15px;
    line-height: 1;
    transform: translate(-50%, 0);
    font-size: 18px;
    border-radius: 10px;
    background: rgb(255, 255, 255);
    color: #333;
}

.navbar-wrap {
    bottom: 40px;
    right: 120px;
    width: calc(658px - 40px - 80px);
    width: 520px;
    height: 100px;
    background: #FFFFFF;
    box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.2);
    border-radius: 20px;
    z-index: 999999;
    .search-wrap {
        padding-left: 19px;
        line-height: 1;
        font-size: 18px;
        color: #666;
        text-align: center;
        .icon-search {
            margin-bottom: 6px;
            width: 48px;
            height: 48px;
            background: url(../assets/images/icon-search.png) no-repeat center;
            background-size: 100%;
            &.active {
                background-image: url(../assets/images/icon-search-active.png);
            }
        }
    }
    .icon-left,
    .icon-right {
        width: 48px;
        height: 100%;
        background: url(../assets/images/icon-left.png) no-repeat center;
        background-size: 14px 26px;
    }
    .icon-right {
        background-image: url(../assets/images/icon-right.png);
    }
    .nav-swiper {
        width: 100%;
        height: 100%;
        overflow: hidden;
        .swiper-slide {
            position: relative;
            display: inline-block;
            margin: 5px 0;
            padding: 0 5px;
            width: auto;
            min-width: 88px;
            height: 90px;
            line-height: 1;
            text-align: center;
            color: #666666;
            font-size: 18px;
            text-align: center;
            .nav-item {
                width: 100%;
                height: 100%;
                &.show::before {
                    content: '';
                    display: block;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: #CFCFCF;
                    opacity: 0.3;
                    border-radius: 12px;
                    z-index: -1;
                }
                .nav-icon {
                    margin: 0 auto 10px;
                    width: 46px;
                    height: 46px;
                    background-repeat: no-repeat;
                    background-size: contain;
                }
            }
        }
    }
}

.qrcode-wrap {
    bottom: 40px;
    left: 20px;
    width: 150px;
    height: 150px;
    box-shadow: 0px 0px 18px 0px rgba(0,0,0,0.31);
    border-radius: 10px;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}
.local-tip {
    padding: 0 10px;
    left: 20px;
    bottom: 210px;
    height: 40px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    color: #fff;
    font-size: 18px;
    z-index: 999999;
    .icon-local {
        margin-right: 7px;
        width: 22px;
        height: 29px;
        background: url(../assets/images/icon-local.png) no-repeat center;
        background-size: 100%;
    }
}
.notice-wrap {
    top: 20px;
    left: 30px;
    height: 60px;
    min-width: 60px;
    background: rgba(0,0,0,0.4);
    color: #fff;
    font-size: 26px;
    border-radius: 30px;
    z-index: 999999;
}
.icon-notice {
    margin: 0 18px;
    width: 33px;
    height: 29px;
    background: url(../assets/images/icon-notice.png) no-repeat center;
    background-size: contain;
    flex-shrink: 0;
}
.icon-close-min {
    margin: 0 18px;
    width: 24px;
    height: 24px;
    background: url(../assets/images/icon-close-min.png) no-repeat center;
    background-size: contain;
    flex-shrink: 0;
    &.min {
        margin: 0 0 0 8px;
        width: 18px;
        height: 18px;
    }
}
.notice-list {
    width: calc(40vw - 72px - 30px);
}
.notice-item {
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.notice-anim {
    display: inline-block;
    line-height: 60px;
    white-space: nowrap;
    word-break: keep-all;
    transform: translateX(40%);
    transform: translateX(calc(40vw - 72px - 30px));
    animation: 20s 0s notice-run infinite linear;
}
.notice-fade-enter-active, .notice-fade-leave-active {
  transition: all .25s ease;
}
.notice-fade-enter, .notice-fade-leave-to {
  transform: translateX(-200%);
}

@keyframes notice-run {
  0% { transform: translateX(100%);transform: translateX(calc(40vw - 72px - 30px)); }
  100% { transform: translateX(-100%); }
}

.notice-list-fade-enter-active, .notice-list-fade-leave-active {
  transition: all .25s ease;
}

.notice-list-fade-enter, .notice-list-fade-leave-to {
  width: 0;
  opacity: 0;
}
.locate-wrap {
    top: 50%;
    left: 50%;
    width: 36px;
    height: 36px;
    transform: translate(-50%, -50%);
    .icon-screen-local {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url(../assets/images/icon-local.png);
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
    }
}
.panel-wrap {
    top: 24px;
    bottom: 148px;
    bottom: 40px;
    right: 120px;
    width: 520px;
    max-height: 820px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.2);
    border-radius: 20px;
    z-index: 999999;
    &.p-center {
        right: 50%;
        margin-right: -260px;
    }
}
.wrap-fade-2top-enter-active,
.wrap-fade-enter-active {
  transition: all .15s ease;
}
.wrap-fade-2top-leave-active,
.wrap-fade-leave-active {
  transition: all .15s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.wrap-fade-enter, .wrap-fade-leave-to {
  transform: translateX(200%);
}
.wrap-fade-2top-enter, .wrap-fade-2top-leave-to {
  transform: translateY(200%);
}
.panel-title {
    padding: 0 15px;
    width: 100%;
    height: 64px;
    .panel-t-l {
        width: 80px;
        font-size: 18px;
        color: #666666;
        .icon-return {
            margin-right: 7px;
            width: 12px;
            height: 17px;
            background: url(../assets/images/icon-return.png) no-repeat center;
            background-size: 100%;
        }
    }
    .panel-t-r {
        width: 80px;
        .icon-close {
            width: 36px;
            height: 36px;
            background: url(../assets/images/icon-close.png) no-repeat center;
            background-size: 100%;
        }
    }
    .panel-t-c {
        text-align: center;
        font-size: 24px;
        font-weight: 700;
    }
}
.panel-swiper {
    width: 100%;
    height: calc(100% - 64px);
    iframe {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
    .wrap-swiper {
        width: 100%;
        height: 100%;
        .swiper-slide {
            width: 100%;
            height: auto;
            .panel-cover-wrap {
                width: 100%;
                height: 228px;
                background-color: #319ef0;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                .swiper-container {
                    width: 100%;
                    height: 100%;
                    .swiper-slide {
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: cover;
                    }
                }
            }
            .panel-content {
                padding: 20px 30px;
                img {
                    max-width: 100%;
                }
                .panel-c-title {
                    margin-bottom: 15px;
                    font-size: 22px;
                    line-height: 1;
                    font-weight: 700;
                    .panel-c-t {
                        display: inline-block;
                        &::after {
                            content: '';
                            display: block;
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                            height: 10px;
                            background: #319ef0;
                            z-index: -1;
                        }
                    }
                }
                &.gaikuang-content {
                    .content-title {
                        font-size: 24px;
                        font-weight: 700;
                        flex-wrap: wrap;
                        align-items: flex-start;
                    }
                    
                    .info-distance,
                    .info-address {
                        margin-top: 12px;
                        font-size: 20px;
                        color: #666;
                        line-height: 1;
                        .txt-distance {
                            margin-left: 15px;
                            color: #CB7C00;
                            font-weight: 700;
                        }
                    }
                    .icon-distance,
                    .icon-address {
                        margin-right: 15px;
                        width: 18px;
                        height: 20px;
                        background: url(../assets/images/icon-distance.png) no-repeat center;
                        background-size: 100% 100%;
                    }
                    .icon-address {
                        background-image: url(../assets/images/icon-address.png);
                    }
                    .more-markers {
                        .swiper-slide {
                            width: auto;
                            .more-marker-cover {
                                width: 160px;
                                height: 160px;
                                border-radius: 10px;
                                background-color: #319ef0;
                                background-repeat: no-repeat;
                                background-position: center;
                                background-size: cover;
                            }
                            .more-marker-name {
                                margin: 10px 0;
                                font-size: 18px;
                                line-height: 1;
                            }
                            .more-marker-dis {
                                color: #666;
                                font-size: 14px;
                                span {
                                    color: #319ef0;
                                    font-weight: 700;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
.float-title .panel-title {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    .panel-t-l {
        color: #fff;
        .icon-return {
            background-image: url(../assets/images/icon-return-white.png);
        }
    }
    .panel-t-r {
        .icon-close {
            background-image: url(../assets/images/icon-close-white.png);
        }
    }
}
.float-title .panel-swiper {
    height: 100%;
}
.list-search {
    padding: 7px 30px;
    .input-wrap {
        padding: 8px 16px;
        width: 100%;
        height: 50px;
        background: #E6E6E6;
        border-radius: 10px;
        font-size: 22px;
        .icon-input-search {
            margin-right: 13px;
            width: 33px;
            height: 33px;
            background: url(../assets/images/icon-search2.png) no-repeat center;
            background-size: contain;
        }
        .input-search {
            background: transparent;
        }
    }
}
.list-swiper-wrap {
    width: 100%;
    height: calc(100% - 64px - 64px);
    .list-swiper {
        width: 100%;
        height: 100%;
        .swiper-slide {
            padding: 0 30px;
            height: auto;
            .list-item {
                padding: 20px 0;
                font-size: 22px;
                line-height: 1;
                .list-icon {
                    margin-right: 16px;
                    width: 47px;
                    height: 44px;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: contain;
                }
            }
        }
        
    }
}
.info-wrap {
    padding: 20px;
    width: 532px;
    height: 246px;
    .info-cover-wrap {
        margin-right: 18px;
        width: 108px;
        height: 108px;
        border-radius: 100%;
        overflow: hidden;
        .info-cover {
            width: 100%;
            height: 100%;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            .icon-audio {
                top: 50%;
                left: 50%;
                width: 24px;
                height: 24px;
                transform: translate(-50%, -50%);
                background: url(../assets/images/icon-play.png) no-repeat center;
                background-size: 100%;
                &.playing {
                    background-image: url(../assets/images/icon-pause.png);
                }
            }
        }
    }
    .info-name {
        font-size: 22px;
        line-height: 1;
        font-weight: 700;
    }
    .info-tag {
        display: inline-block;
        padding: 5px 10px;
        margin-right: 16px;
        margin-top: 12px;
        font-size: 16px;
        line-height: 1;
        color: #fff;
        background: #83D766;
        border-radius: 6px;
    }
    .info-distance,
    .info-address {
        margin-top: 12px;
        font-size: 20px;
        color: #666;
        line-height: 1;
        .txt-distance {
            margin-left: 15px;
            color: #CB7C00;
            font-weight: 700;
        }
    }
    .icon-distance,
    .icon-address {
        margin-right: 15px;
        width: 18px;
        height: 20px;
        background: url(../assets/images/icon-distance.png) no-repeat center;
        background-size: 100% 100%;
    }
    .icon-address {
        background-image: url(../assets/images/icon-address.png);
    }
}
.info-btns {
    .info-btn {
        padding: 10px;
        border: 2px solid #319ef0;
        border-radius: 10px;
        font-size: 20px;
        color: #3C3401;
        font-weight: 700;
        & +.info-btn {
            margin-left: 20px;
        }
        &.info-btn-go {
            background: #319ef0;
            color: #fff;
            .icon-go {
                background-image: url(../assets/images/icon-go2.png);
            }
        }
        .info-btn-icon {
            margin-right: 15px;
            width: 22px;
            height: 22px;
            background: url(../assets/images/icon-detail.png) no-repeat center;
            background-size: 100% 100%;
        }
        .icon-go {
            background-image: url(../assets/images/icon-go.png);
        }
    }
}

.panel-count {
    font-size: 16px;
    color: #666666;
    text-align: center;
    line-height: 1;
}
.panel-list {
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #EDEDED;
    &.panel-list-in {
        margin: -15px -30px 0;
        width: auto;
    }
    .swiper-slide {
        padding: 0 30px;
        width: auto!important;
        color: #999999;
        font-size: 18px;
        &.active {
            font-size: 20px;
            font-weight: 700;
            color: #333;
            &::after {
                content: '';
                display: block;
                position: absolute;
                bottom: 0;
                width: 48px;
                left: 50%;
                height: 5px;
                background: #319ef0;
                box-shadow: 0px 5px 9px 0px rgba(255,203,41,0.47);
                border-radius: 3px;
                transform: translateX(-50%);
            }
        }
    }
}
.panel-swiper2 {
    width: 100%;
    height: calc(100% - 64px - 16px - 60px);
    .swiper-slide {
        width: 100%;
        height: auto;
        .line-info {
            padding: 20px 30px;
            border-bottom: 6px solid #F6F6F6;
            .line-descs {
                padding-top: 10px;
                flex-wrap: wrap;
                .line-desc {
                    position: relative;
                    font-size: 16px;
                    color: #666;
                    line-height: 1;
                    &+.line-desc {
                        padding-left: 34px;
                        &::before {
                            content: '';
                            display: block;
                            position: absolute;
                            top: 50%;
                            left: 17px;
                            width: 1px;
                            height: 14px;
                            background: #666;
                            transform: translateY(-50%) scaleX(0.5);
                        }
                    }
                }
            }
            .line-markers {
                margin-top: 20px;
                width: 100%;
                height: auto;
                .swiper-slide {
                    width: auto;
                    &+.swiper-slide {
                        padding-left: 20px;
                    }
                    .line-marker-line {
                        position: absolute;
                        top: 50%;
                        left: 0;
                        width: 100%;
                        border-bottom: 1px dashed #319ef0;
                        transform: translateY(-50%);
                        z-index: -1;
                    }
                    .line-marker-index {
                        width: 39px;
                        height: 39px;
                        background: #a7d7fc;
                        border: 1px dashed #319ef0;
                        border-radius: 50%;
                        font-size: 20px;
                        color: #fff;
                        &.selected {
                            border-style: solid;
                            background: #319ef0;
                        }
                    }
                }
            }
        }
        .line-marker-info {
            padding: 20px 30px;
            .info-name {
                font-size: 24px;
                font-weight: 700;
            }
            .info-distance {
                font-size: 16px;
                color: #666;
                .icon-distance {
                    display: inline-block;
                    margin-right: 10px;
                    width: 18px;
                    height: 20px;
                    background: url(../assets/images/icon-distance.png) no-repeat center;
                    background-size: 100%;
                }
                .txt-distance {
                    margin-left: 10px;
                    font-size: 16px;
                    color: #cb7c00;
                    font-weight: 700;
                }
            }
            .panel-c-title {
                margin-top: 20px;
                margin-bottom: 15px;
                font-size: 22px;
                line-height: 1;
                font-weight: 700;
                .panel-c-t {
                    display: inline-block;
                    &::after {
                        content: '';
                        display: block;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 10px;
                        background: #319ef0;
                        z-index: -1;
                    }
                }
            }
        }
    }
}

.ueditor-html {
    margin-bottom: 15px;
    font-size: 16px;
}
.audio-ctrl-wrap {
    padding: 5px 15px 5px 5px;
    width: 100%;
    height: 60px;
    background: #F6F6F6;
    border-radius: 30px;
    .audio-cover {
        margin-right: 10px;
        width: 50px;
        height: 50px;
        background-color: #319ef0;
        border-radius: 100%;
        overflow: hidden;
        .icon-audio {
            top: 50%;
            left: 50%;
            width: 15px;
            height: 15px;
            background: url(../assets/images/icon-play.png) no-repeat center;
            background-size: 100%;
            transform: translate(-50%, -50%);
        }
        &.playing {
            .icon-audio {
                background-image: url(../assets/images/icon-pause.png);
            }
        }
    }
    .audio-time {
        width: 60px;
        font-size: 16px;
        &.r {
            text-align: right;
        }
    }
}
.dev-swiper {
    width: 100%;
    height: 100%;
    z-index: 2;
}
.weui-picker__indicator {
    top: 50%;
    padding: 18px 0;
    height: 1.42em;
    transform: translateY(-50%);
}
}
</style>


// WEBPACK FOOTER //
// src/components/Index.vue